import { render, staticRenderFns } from "./ArticleauthorAutocomplete.vue?vue&type=template&id=6d7c5c6b&"
import script from "./ArticleauthorAutocomplete.vue?vue&type=script&lang=js&"
export * from "./ArticleauthorAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports